module.exports = __webpack_public_path__ + "static/futura-book-eecd612fa5f3095cb55c6b24afea0c19.woff2";